import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminApi } from "../api";

const TILES = [
  { key: "pages", label: "Pages", to: "/admin/pages" },
  { key: "services", label: "Services", to: "/admin/services" },
  { key: "industries", label: "Industries", to: "/admin/industries" },
  { key: "compliance", label: "Compliance", to: "/admin/compliance" },
  { key: "faqs", label: "FAQs", to: "/admin/faqs" },
  { key: "news", label: "News posts", to: "/admin/news" },
  { key: "publications", label: "Publications", to: "/admin/publications" },
  { key: "submissions", label: "Submissions", to: "/admin/submissions" },
];

export default function Dashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { adminApi.get("/admin/dashboard").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="adm-head">
        <div>
          <h1>Dashboard</h1>
          <div className="sub">Lemur Quality content management — changes publish instantly</div>
        </div>
        <a className="adm-btn ghost" href="/" target="_blank" rel="noreferrer" data-testid="view-site">View public site ↗</a>
      </div>

      <div className="adm-grid cols-4" style={{ marginBottom: 22 }}>
        {TILES.map((t) => (
          <Link to={t.to} key={t.key} className="stat-tile" data-testid={`tile-${t.key}`}>
            <div className="n">{data?.counts?.[t.key] ?? "—"}</div>
            <div className="l">{t.label}{t.key === "submissions" && data?.counts?.submissions_new ? ` (${data.counts.submissions_new} new)` : ""}</div>
          </Link>
        ))}
      </div>

      <div className="adm-card">
        <h2>Recent contact submissions</h2>
        <table className="adm-table">
          <thead><tr><th>Date</th><th>Name</th><th>Subject</th><th>Status</th></tr></thead>
          <tbody>
            {(data?.recent_submissions || []).map((s) => (
              <tr key={s.id}>
                <td className="mono">{(s.created_at || "").slice(0, 10)}</td>
                <td>{s.name}</td>
                <td>{s.subject} {s.is_consultation && <span className="adm-badge consult">consultation</span>}</td>
                <td><span className={`adm-badge ${s.status || "new"}`}>{s.status || "new"}</span></td>
              </tr>
            ))}
            {(!data || data.recent_submissions?.length === 0) && <tr><td colSpan={4} className="adm-empty">No submissions yet.</td></tr>}
          </tbody>
        </table>
        <div style={{ marginTop: 12 }}><Link className="adm-btn ghost sm" to="/admin/submissions">Open inbox</Link></div>
      </div>
    </div>
  );
}
